var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { fixed: _vm.comment.isFixed } }, [
    _c("div", { staticClass: "comment-piece" }, [
      _vm.isCompanyStaffAccess && _vm.comment.isFixed
        ? _c(
            "div",
            {
              staticClass: "red fixed-label",
              attrs: { "data-test": "fixed-for-boss-c" },
            },
            [_vm._v("\n      修正済み\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCompanyStaffAccess
        ? _c("div", { attrs: { "data-test": "fixed-for-boss-s" } }, [
            _c(
              "label",
              {
                staticClass: "boss-checkbox",
                class: { red: _vm.comment.isFixed },
                attrs: { "data-test": "checkbox-label" },
              },
              [
                _c("input", {
                  staticClass: "boss-input-checkbox",
                  attrs: { "data-test": "checkbox", type: "checkbox" },
                  domProps: { checked: _vm.comment.isFixed },
                  on: { click: _vm.toggleFixed },
                }),
                _vm._v(
                  _vm._s(_vm._f("fixedText")(_vm.comment.isFixed)) + "\n      "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { "data-test": "businesses-partner-name" } }, [
        _vm._v(
          "\n      【" +
            _vm._s(
              _vm._f("businessesPartnerName")(_vm.comment.isCompanyStaff)
            ) +
            "コメント】\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "comment-update-date",
          attrs: { "data-test": "author-and-date" },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.comment.author) +
              _vm._s(_vm._f("honorific")(_vm.comment.isCompanyStaff)) +
              "（" +
              _vm._s(_vm._f("formatDate")(_vm.comment.lastUpdateDate)) +
              "）\n    "
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isEdit
        ? _c("div", {
            staticClass: "comment pega-pre-wrap",
            attrs: { "data-test": "comment" },
            domProps: { textContent: _vm._s(_vm.comment.comment) },
          })
        : _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.comment.comment,
                expression: "comment.comment",
              },
            ],
            staticClass: "edit-comment",
            class: { pending: _vm.isPending },
            attrs: { "data-test": "edit-comment" },
            domProps: { value: _vm.comment.comment },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.comment, "comment", $event.target.value)
              },
            },
          }),
      _vm._v(" "),
      _vm.canEdit
        ? _c(
            "div",
            {
              staticClass: "edit-area",
              attrs: { "data-test": "edit-icon-area" },
            },
            [
              _c("button", {
                staticClass: "boss-icon-pencil",
                attrs: { "data-test": "icon-pencil" },
                on: { click: _vm.toggleEdit },
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "boss-icon-trash",
                attrs: { "data-test": "icon-trash" },
                on: { click: _vm.doRemove },
              }),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("hr"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }